import type { ProductNameLineType } from 'autogen/swagger/all';
import type { BodySize } from 'components/generic/typography/components/Body';
import type { LabelSize } from 'components/generic/typography/components/Label';
import type { IProductNameSize } from './types';

type BrandType = {
    Brand: LabelSize;
};

export type ProductNameLineThemeTypes = {
    [IProductNameSizeKey in IProductNameSize]: BrandType & {
        [ProductNameLineTypeKey in Extract<ProductNameLineType, 'Name' | 'Variant'>]: BodySize;
    };
};

export const ProductNameLineTheme: ProductNameLineThemeTypes = {
    sm: {
        Brand: 'S',
        Name: 'S',
        Variant: 'S'
    },
    md: {
        Brand: 'M',
        Name: 'M',
        Variant: 'M'
    },
    lg: {
        Brand: 'M',
        Name: 'L',
        Variant: 'L'
    }
};
